module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/venue_owner/goal_empty-48023144466291b08d0d2a89281ccbfb.png";